
const initialState = {
    list: null,
    workingShift: null,
    otherExpenditures: null,
    filters: {
        point: null,
        createdStartDate: null,
        createdEndDate: null,
        id: null
    },
    typeMovementCash: null,
    detailArticle: null,
    devices: {
      filters: {
        point: null,
        city: null,
        id: null,
        deviceId: null,
      },
      list: [],
      add: {},
      detail: {},
      edit: {},
      count: 0,
      paging: {
        start: 0,
        limit: 10
      }
    },
    plannedRevenue: null,
    wages: null,
};

export default function cassa(state = initialState, action) {
    switch(action.type) {
      case 'SET_CASSA': {
        return {
            ...state,
            [action.field]: action.data
        };
      }
      case 'SET_WORKING_SHIFTS': {
            return {
                ...state,
                list: action.data
            };
      }
      case 'SET_WORKING_SHIFT': {
            return {
                ...state,
                workingShift: action.data
            };
      }
      case 'SET_DEVICES_LIST': {
        return {
          ...state,
          devices: {
            ...state.devices,
            list: action.data
          }
        }
      }
      case 'SET_DEVICES_COUNT': {
        return {
          ...state,
          devices: {
            ...state.devices,
            count: action.data
          }
        }
      }
      case 'SET_DEVICE_DETAIL': {
        return {
          ...state,
          devices: {
            ...state.devices,
            detail: action.data
          }
        }
      }
      case 'SET_ADD_DEVICE': {
        return {
            ...state,
            devices: {
              ...state.devices,
              add: action.data
            }
        };
      }
      case 'SET_DEVICE': {
        return {
          ...state,
          devices: {
            ...state.devices,
            detail: action.data
          }
        };
      }
      case 'SET_EDIT_DEVICE': {
        return {
          ...state,
          devices: {
            ...state.devices,
            edit: action.data
          }
        };
      }
      case 'SET_OTHER_EXPENDITURES': {
        return {
            ...state,
            otherExpenditures: action.data
            };
      }
      case 'SET_CASSA_FILTERS': {
        return {
            ...state,
            filters: action.filters
        };
      }
      case 'SET_DEVICES_FILTERS': {
        return {
          ...state,
          devices: {
            ...state.devices,
            filters: action.filters
          }
        }
      }
      case 'SET_DEVICES_PAGING': {
        return {
            ...state,
            devices: {
              ...state.devices,
              paging: action.paging
            }
        };
      }
      case 'SET_TYPE_MOVEMENT_CASH': {
        return {
            ...state,
            typeMovementCash: action.typeMovementCash
        };
      }
      case 'SET_DETAIL_ARTICLE': {
        return {
            ...state,
            detailArticle: action.data
        };
      }
    default: return state;
    }
  }